import { render } from "./IconSettings.vue?vue&type=template&id=8c52137e"
import script from "./IconSettings.vue?vue&type=script&lang=js"
export * from "./IconSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c52137e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c52137e', __exports__)) {
    api.reload('8c52137e', __exports__)
  }
  
  module.hot.accept("./IconSettings.vue?vue&type=template&id=8c52137e", () => {
    api.rerender('8c52137e', render)
  })

}


export default __exports__